import { type ContestEntryBonusSchedule } from 'src/types/api'
import { type DayName, daysOfWeek } from 'utils/util'

export const addMissingDays = (schedules: ContestEntryBonusSchedule[]) => {
  const allDays: ContestEntryBonusSchedule[] = [
    {
      id: 0,
      dayName: 'Monday',
      opening: '',
      closing: '',
      patronContestEntryBonusMultiplier: 3,
    },
    {
      id: 1,
      dayName: 'Tuesday',
      opening: '',
      closing: '',
      patronContestEntryBonusMultiplier: 3,
    },
    {
      id: 2,
      dayName: 'Wednesday',
      opening: '',
      closing: '',
      patronContestEntryBonusMultiplier: 3,
    },
    {
      id: 3,
      dayName: 'Thursday',
      opening: '',
      closing: '',
      patronContestEntryBonusMultiplier: 3,
    },
    {
      id: 4,
      dayName: 'Friday',
      opening: '',
      closing: '',
      patronContestEntryBonusMultiplier: 3,
    },
    {
      id: 5,
      dayName: 'Saturday',
      opening: '',
      closing: '',
      patronContestEntryBonusMultiplier: 3,
    },
    {
      id: 6,
      dayName: 'Sunday',
      opening: '',
      closing: '',
      patronContestEntryBonusMultiplier: 3,
    },
  ]
  schedules.forEach((day) => {
    const indexToReplace = daysOfWeek.indexOf((day.dayName as DayName) ?? '')
    allDays[indexToReplace] = day
  })
  return allDays
}
